import * as React from "react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface IconButtonWithTooltipProps extends React.ComponentPropsWithoutRef<typeof Button> {
  id?: string;
  tooltip: string;
  icon: React.ReactNode;
  tooltipSide?: "top" | "right" | "bottom" | "left";
}

export const IconButtonWithTooltip = React.forwardRef<
  HTMLButtonElement,
  IconButtonWithTooltipProps
>(({ id, tooltip, icon, tooltipSide = "top", className, ...props }, ref) => {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <Button id={id} ref={ref} className={cn(className)} {...props}>
            {icon}
          </Button>
        </TooltipTrigger>
        <TooltipContent
          side={tooltipSide}
          align="center"
          sideOffset={5}
          className="bg-gray-900 text-white border-gray-800"
        >
          {tooltip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
});

IconButtonWithTooltip.displayName = "IconButtonWithTooltip";
